import {connect} from 'react-redux';
import CommissionsList from "./CommissionsList";
import {MODAL_REMOVE_COMMISSION, showModal} from "../../../reducers/common/activeModal";
import {getTranslation} from "../../../reducers/common/localization";
import {
    fetchGetCommissions, 
    getCommissionsData, 
    loadingCommissions,
    setCommissionToRemove,
    fetchGetBAsList,
    getBAsList,
    loadingBAsList,
    getCommissionsBAFilter,
    updateCommissionsBAFilter,
    getCommissionsCountryFilter,
    updateCommissionsCountryFilter
} from "../../../reducers/commission/commissions";
import { 
    getContinentsData, 
    getCurrentContinent, 
    getCountriesData, 
    setCurrentContinent
} from '../../../reducers/common/location';

const mapStateToProps = state => {
    return {
        loading: loadingCommissions(state) || loadingBAsList(state),
        translation: getTranslation(state),
        data: getCommissionsData(state),
        BAsList: getBAsList(state),
        continents: getContinentsData(state),
        continentCode: getCurrentContinent(state),
        countries: getCountriesData(state),
        countryFilter: getCommissionsCountryFilter(state),
        BAFilter: getCommissionsBAFilter(state)
    };
};


const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(fetchGetCommissions());
            dispatch(fetchGetBAsList())
        },
        onCommissionRemove: (commissionId) => {
            dispatch(setCommissionToRemove(commissionId));
            dispatch(showModal({modalKey: MODAL_REMOVE_COMMISSION}));
        },
        onSetContinent: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        onCountryFilterChange: (countryCode) => {
            dispatch(updateCommissionsCountryFilter(countryCode));
        },
        onBAFilterChange: (baId) => {
            dispatch(updateCommissionsBAFilter(baId))
        },
        onUnmount: () => {
            dispatch(setCurrentContinent(""));
            dispatch(updateCommissionsCountryFilter(null));
            dispatch(updateCommissionsBAFilter(null))
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(CommissionsList);



// WEBPACK FOOTER //
// ./src/components/paymentManagement/commissionsList/CommissionsList.container.js